var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.topickIcon,
      "alt": "topick"
    }
  }), _vm._m(0)]), _c('m-button', {
    staticClass: "btn",
    on: {
      "click": _vm.handleClickBtn
    }
  }, [_c('k18n', [_vm._v("Learn More")])], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" Topick-a Kwai app ")]), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(" A Enciclopédia da Vida do Brasileiro ")])]);
}]

export { render, staticRenderFns }